<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box">


          <div class="swipe-box" v-if="picList.length > 0">
            <van-swipe indicator-color="#F7B500" :duration="300">
              <van-swipe-item v-for="(item, index) in picList" :key="index">
                <!-- <router-link :to="'/'+item.url.name+'?id='+item.url.query.id"> -->
                <img :src="item.pic_url" alt v-rblink="{name:'NewsDetail',query:{id:item.id }}"/>
                <!-- </router-link> -->
              </van-swipe-item>
            </van-swipe>
          </div>

          <div class="jingwai-title">
            <p class="icon1"></p>
            <p class="title">境外活动</p>
            <p class="title2">Events</p> 
          </div>

        <div class="zhou-wrap">
          <div>
            <img v-rblink="{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 125 } }"  src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/8a6f98da6f5338e4f491af60367fefc0.png" />
            <img v-rblink="{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 124 } }"  src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/db300ab269a7303024c46bc295d51643.png" />
          </div>
          <div>
            <img v-rblink="{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 128 } }"  src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/3b8b466099e903ab6d8c63530b1647be.png" />
            <img v-rblink="{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 126 } }"  src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/3f10a8bfe8038a47bab67604d0cef20f.png" />
            <img v-rblink="{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 127 } }"  src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/fa547d1f8da0525ee3658dd49183374c.png" /> 
          </div>
        </div>
          <div class="jingwai-title">
            <p class="icon1"></p>
            <p class="title">活动新闻</p>
            <p class="title2">News</p>
            <p class="more"  v-rblink="{name:'NewsList',query:{cate_id:57 }}">更多 &gt;</p>
          </div>

           

          <div v-for="(row,i) in list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}">
            <!-- 无图 style==1 -->
            <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>
            <!-- 有图 style==2 -->
            <NewsItem2 :row="row" v-if="row.pics.length==1"></NewsItem2>
            <!-- 视频 style==3 -->
            <NewsItem3 v-if="false"></NewsItem3>
            <!-- 多图 style==4 -->
            <NewsItem4 :row="row" v-if="row.pics.length>1"></NewsItem4>
          </div>


          <div class="jingwai-title">
            <p class="icon1"></p>
            <p class="title">常见问题</p>
            <p class="title2">FAQs</p>
            <p class="more">更多 &gt;</p>
          </div>


            <van-cell-group> 
               <van-cell v-rblink="{name:'NewsDetail',query:{id:668 }}" title="·参与资格"  is-link/>
               <van-cell v-rblink="{name:'NewsDetail',query:{id:669 }}" title="·参与流程" is-link/>
               <van-cell v-rblink="{name:'NewsDetail',query:{id:670 }}" title="·出访提示" is-link/>
               <van-cell v-rblink="{name:'NewsDetail',query:{id:671 }}" title="·技术支持" is-link/>
            </van-cell-group>
    </div>
  </div>
</template>
<style scoped>
.swipe-box {
  margin: .2rem;
}

.swipe-box img {
  width: 100%;
  height: 220px;
  border-radius: 5px;
  object-fit: cover;
}
.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
.jingwai-title {
  padding:0 10px;
  height: 40px;
  vertical-align: middle;
}
.jingwai-title .icon1
  {    margin-top: 6px;
    display: inline-block;
    width: 6px;
    height: 26px;
    background: #F7B500;
    border-radius: 0px 39px 0px 0px;
    float: left;
    vertical-align: middle;
  }
.jingwai-title .title{ 
    display: inline-block;
    font-size: 16px; 
    font-weight: 500;
    color: #333333;
    margin: 0 0 0 6px;
    line-height: 40px;
    float: left; 
    vertical-align: middle;
  }
.jingwai-title .title2{
    display: inline-block;
    font-size: 12px; 
    margin: 0 0 0 6px;
    font-weight: 500;
    color: #999;
    line-height: 40px;
    float: left;
    vertical-align: middle;
  }
.jingwai-title  .more{
    display: inline-block;
    font-size: 12px; 
    font-weight: 500;
    color: #999;
    float: right;    
    margin-top: 11px;
    vertical-align: middle;
  } 

  .zhou-wrap{
    padding: 0 10px
  }
  .zhou-wrap div{ 
      display: flex;
      flex-wrap:nowrap;
      margin:10px 0 ;
      justify-content:space-between;  
  }
  .zhou-wrap img{ 
      height: 114px;
  }

.row1 {
  /*padding: 10px;*/
  margin: 0 10px;
}

.row1 img {
  width: 100%;
  margin: 10px 0 0 0;
}

.row3 {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  /*flex-wrap: wrap;*/
}

.row3 img {
  float: left;
  width: calc(33.33% - 10px);
  margin: 0 10px 10px 0;
}

.logo-ul {
  background: #fff;
  border-radius: 10px;
  height: 100px;
  margin: 0 10px;
}

.logo-ul div {
  text-align: center;
  float: left;
  width: calc(33.33% - 10px);
  margin: 0 0 10px 10px;
  line-height: 110px;
  height: 110px;
}

.logo-ul img {
  width: 100%;
  display: inline-block;
}

</style>

<script>
import Vue from "vue";
import {Tab, Tabs, List, PullRefresh, Toast} from "vant";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";

Vue.use(Tab)
    .use(Tabs)
    .use(PullRefresh)
    .use(List)
    .use(Toast);

export default {
  name: "NewsList",
  components: {
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4
  },

  data: function () {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [],
      catelist: [],
      list: [],
      picList: [],
      params: {
        cate_id: 57,
        pageNo: 1,
        pageSize: 10
      },
    };
  },
  filters: {},
  mounted() {
    document.title = "境外交流";
    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;  
    let that = this;

    that.$api.get(
        "/api/cms/cmsList", {
          cate_id: 57,
          pageSize:5
        },
        res => {
          that.list = res.data.list
        },
        res => {
          Toast(res.msg);
        }
    );
    that.$api.get(
        "/api/cms/cmsList", {
          cate_id: 122
        },
        res => {
          that.picList = res.data.list
        },
        res => {
          Toast(res.msg);
        }
    );

 
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
          "/api/cms/cmsList", that.params,
          res => {

            that.loading = false;
            console.log('fetchok')
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }

            if (res.data.list.length == 0) {
              that.finished = true;
            }
            that.params.pageNo += 1;
            that.getPicList()
          },
          res => {
            Toast(res.msg);
          }
      );
    },

    getPicList() {
      let list = []
      this.list.map(row => {
        if(row.pics.length > 0 && list.length < 10) {
          list.push(row)
        }
      })

      this.picList = list

      console.log('picList', list)
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.fetch();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// Guojijiaoliu.vue?25931df7